import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';
import { CoreApisService } from '../core-apis.service';
import { CommonModule } from '@angular/common';
import { ToHtmlPipe } from 'src/app/shared/utilities/to-htmlpipe/to-html.pipe';
import { TalkToSalesButtonComponent } from 'src/app/shared/components/talktosalesButton/talktosalesButton.component';

@Component({
  selector: 'app-core-api-hero',
  templateUrl: './core-api-hero.component.html',
  styleUrls: ['./core-api-hero.component.scss'],
  imports: [CommonModule, ToHtmlPipe, TalkToSalesButtonComponent],
})
export class CoreApiHeroComponent implements OnInit, OnDestroy {
  @ViewChild('registerLink') registerLink: any;
  
  constructor(private coreApiPageService: CoreApisService) {
    this.subscriptions = [];
  }

  backgroundImageUrl:any;
  highlightedText:any;

  ngOnDestroy(): void {
    if (this.subscriptions && this.subscriptions.length > 0) {
      this.subscriptions.forEach(subscription => {
        subscription.unsubscribe();
      });
    }
  }

  coreApiData: any;
  subscriptions: Subscription[];

  ngOnInit(): void {
    this.coreApiPageService.coreApiHero$.subscribe(data => {
      if (data !== null) {
        this.coreApiData = data;
        this.backgroundImageUrl = `url(${data.image[1]?.fields?.file?.url})`;
        this.highlightedText = data.title.replace(
          /Verto Core APIs/g,
          '<span class="moonstone">Verto Core APIs</span>'
        );
      }
    });
  }
  openRegisterLink(event:any, target?:string) {
    event.preventDefault();
    const link = this.registerLink.nativeElement.href;
    const searchParams = location.search !== '' ? location.search.slice(1) : '';
    let linkHasParams = new URLSearchParams(link) as any;
    let url = link;
    if(searchParams !== ''){
      if(linkHasParams.search > 0){
        url = `${link}&${searchParams}`;
      }else{
        url = `${link}?${searchParams}`;
      }
    }
    window.open(url, target || '_blank');
  }
}
